import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme';
import './App.css';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import BannerManagement from './components/BannerManagement';
import AdminManagement from './components/AdminManagement';
import InquiryManagement from './components/inquiry/InquiryManagement';
import UserManagement from './components/user/UserManagement';
import Layout from './components/Layout';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="/dashboard" element={<Layout><Dashboard /></Layout>} />
          <Route path="/banners" element={<Layout><BannerManagement /></Layout>} />
          <Route path="/admin" element={<Layout><AdminManagement /></Layout>} />
          <Route path="/inquiries" element={<Layout><InquiryManagement /></Layout>} />
          <Route path="/users" element={<Layout><UserManagement /></Layout>} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
